// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectCustomListMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { AliasesGroup } from "../Groups/GroupsImport.js";
export let CustomListMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
};

CustomListMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

CustomListMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectCustomListMessage();
    let ff = FieldsFactory;

    msg.Id = fs.GetValue(ff.FIELD_ID);
    msg.Name = fs.GetValue(ff.FIELD_NAME);
    msg.Description = fs.GetValue(ff.FIELD_DESCRIPTION);
    msg.ListType = fs.GetValue(ff.FIELD_LIST_TYPE);

    msg.RawBytes = fs.GetValue(ff.FIELD_RAW_BYTES);
    msg.TradableInstrumentId = fs.GetValue(ff.FIELD_TRADABLE_INSTRUMENT_IDS);

    msg.Aliases = AliasesGroup.GetFromFieldSet(fs);

    return [msg]
};